/*
 * Creates a standard action object for redux dispatches with keys:
 *
 * gameId: String - id of the game that is firing this action
 * type: String - your redux action type
 * payload: Any - the data to send with your redux action
 *
 * Example:
 * dispatch(createActionObj('connectives', 'SELECT_ANSWER', selectedAnswer))
 *
*/

export default function (gameId, type, payload) {
  return {
    gameId,
    type,
    payload,
  };
}
